import type { ApiResponse } from "@portfolio/types";

const API_BASE = import.meta.env.VITE_API_URL ?? "https://nguyennhatduy.qzz.io";

export async function apiGet<T>(path: string): Promise<T | null> {
  const res = await fetch(`${API_BASE}${path}`);
  const json: ApiResponse<T> = await res.json();
  return json.success ? (json.data ?? null) : null;
}

export async function apiPost<T>(path: string, body: unknown): Promise<ApiResponse<T>> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return res.json();
}

async function apiAdminRequest<T>(
  method: "POST" | "PATCH" | "DELETE",
  path: string,
  password: string,
  body?: unknown
): Promise<ApiResponse<T>> {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json", "X-Admin-Password": password },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  return res.json();
}

export const apiAdminPost = <T>(path: string, password: string, body: unknown) =>
  apiAdminRequest<T>("POST", path, password, body);

export const apiAdminPatch = <T>(path: string, password: string, body: unknown) =>
  apiAdminRequest<T>("PATCH", path, password, body);

export const apiAdminDelete = <T>(path: string, password: string) =>
  apiAdminRequest<T>("DELETE", path, password);
